export default __webpack_public_path__ + "static/media/payments.69500bab.svg";